import React, { useMemo } from 'react';
import {
    DashboardOutlined,
    FundOutlined,
    ProjectOutlined,
    SettingOutlined,
    SwapOutlined,
    CloudDownloadOutlined,
    SafetyCertificateOutlined,
    BarChartOutlined,
    UserSwitchOutlined,
    CustomerServiceOutlined,
    FileTextOutlined,
    ImportOutlined,
    AppstoreOutlined,
} from '@ant-design/icons';

export const useIconMap = () => {
    return useMemo(
        () => ({
            dashboard: <DashboardOutlined style={{ color: 'white' }} />,
            inventory: <FundOutlined style={{ color: 'white' }} />,
            import: <ImportOutlined style={{ color: 'white' }} />,
            moveGroupsAndApps: <AppstoreOutlined style={{ color: 'white' }} />,
            project: <ProjectOutlined style={{ color: 'white' }} />,
            manage: <SettingOutlined style={{ color: 'white' }} />,
            migrate: <SwapOutlined style={{ color: 'white' }} />,
            backup: <CloudDownloadOutlined style={{ color: 'white' }} />,
            recovery: <SafetyCertificateOutlined style={{ color: 'white' }} />,
            reporting: <BarChartOutlined style={{ color: 'white' }} />,
            admin: <UserSwitchOutlined style={{ color: 'white' }} />,
            support: <CustomerServiceOutlined style={{ color: 'white' }} />,
            documentation: <FileTextOutlined style={{ color: 'white' }} />,
        }),
        [],
    );
};
